import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

/** Two-step destructive action: first click asks, second click does it. */
export function ConfirmButton({ label, confirmLabel, confirming, onAsk, onCancel, onConfirm, pending }: {
  label: string; confirmLabel: string; confirming: boolean; onAsk(): void; onCancel(): void; onConfirm(): void; pending?: boolean;
}) {
  if (!confirming) return <Button variant="outline" size="sm" className="text-destructive hover:text-destructive" onClick={onAsk}>{label}</Button>;
  return (
    <span className="inline-flex gap-1">
      <Button variant="destructive" size="sm" disabled={pending} onClick={onConfirm}>{pending && <Loader2 className="animate-spin" />}{confirmLabel}</Button>
      <Button variant="ghost" size="sm" onClick={onCancel}>Cancel</Button>
    </span>
  );
}
